// extracted by mini-css-extract-plugin
export default {"map":"PointMap_map__a3bhZ","image":"PointMap_image__58HQs","canvas":"PointMap_canvas__VCFw9"};